/**
 * @author: lv.chen
 * @desc: 休闲游戏日报Header组件
 * @date: 2025/12/15
 */
import React from 'react';
import classnames from 'classnames';

import IMG_LOGO_LI from '@intelligence/assets/imgs/casualDailyReports/logo-li.png';
import IMG_LOGO_DATABRAIN from '@intelligence/assets/imgs/casualDailyReports/logo-databrain-big.png';
import IMG_LOGO_GAME from '@intelligence/assets/imgs/casualDailyReports/logo-game.png';
import IMG_HEADER_BG from '@intelligence/assets/imgs/casualDailyReports/header.png';

interface ICasualDailyReportsHeaderProps extends IBaseProps {}

const CasualDailyReportsHeader: React.FC<ICasualDailyReportsHeaderProps> = (props) => {
  const { style, className } = props;

  return (
    <div style={style} className={classnames('dbi-casual-daily-reports-header dbi-daily-header', className)}>
      <div className="dbi-daily-header-log-wrap">
        <img className="dbi-header-logo" src={IMG_LOGO_LI} alt="logo" />
        <img className="dbi-header-logo" src={IMG_LOGO_DATABRAIN} alt="logo" />
        <img className="dbi-header-logo dbi-header-logo--game" src={IMG_LOGO_GAME} alt="logo" />
      </div>
      <div className="dbi-header-title">
        <img className="dbi-header-title-img" src={IMG_HEADER_BG} alt="logo" />
      </div>
    </div>
  );
};

export default CasualDailyReportsHeader;
